export default function Loading() {
  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        height: "calc(100vh - 16px)",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <svg
        width="120px"
        height="120px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Cargando"
        role="img"
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="#c5c5c5"
          strokeWidth="3"
          r="13"
          strokeDasharray="61.26105674500097 22.420352248333657"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            repeatCount="indefinite"
            dur="1s"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
          />
        </circle>
      </svg>
    </div>
  );
}
